import { ReactNode } from 'react';

import { CSSProperties } from 'styled-components';
import { ColorScheme } from 'styled-components';
import { RiQuestionLine } from 'react-icons/ri';
import { Tooltip } from '@chakra-ui/react';

import { FCWithChildren } from '~/shared/types/FCWithChildren';

import { Container } from './styles';

interface LabelTextProps {
  tooltip?: ReactNode;
  as?: any;
  color?: ColorScheme;
  readonly noWrap?: boolean;
  fontSize?: number;
  fontWeight?: number;
  containerStyles?: CSSProperties;
}

export const LabelText: FCWithChildren<LabelTextProps> = ({
  tooltip,
  as,
  children,
  noWrap = false,
  color = 'onSurface',
  fontSize = 13,
  fontWeight = 600,
  containerStyles,
}) => {
  return (
    <Container
      fontSize={fontSize}
      as={as}
      color={color}
      noWrap={noWrap}
      fontWeight={fontWeight}
      style={containerStyles}
    >
      <span>{children}</span>

      {tooltip && (
        // @ts-ignore
        <Tooltip label={tooltip} hasArrow closeOnClick={false}>
          <div>
            <RiQuestionLine />
          </div>
        </Tooltip>
      )}
    </Container>
  );
};
